import _ from "lodash";
import React, { useState, useEffect } from "react";
const classNames = require("classnames");

import logger from "../../../utils/LoggerFrontend";
import { Heading } from "../../../Components/Heading";
import Actions from "../../../Actions";
import CampaignCreationStore from "../../../Stores/CampaignCreationStore";
import { Store__System, CustomerSucessController } from "@talentbait/shared-components";
import { withRefluxStore } from "../../../Stores";
import { t } from "i18next";
import { formatIntlNumber } from "../../../utils/Helpers";

const MIN_BUDGET_SIZE = 150; // EURO

const AdAssistantCreatePackages = ({
  setCampaignBudgetData,
  children,
  // Store
  userProfile,
  packages,
  packageId: packageType,
  extraBudgetLocations
}) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (!userProfile) {
      return;
    }

    const orgaId = userProfile.organizationId;
    logger.debug("CampaignCreatePackages:componentDidMount", "called... orgaId:", orgaId);

    Actions.loadPackagesByOrga(orgaId);
  }, [userProfile]);

  const handlePackageSelection = (
    campaignBudget,
    packageId,
    minClicks,
    selectedChannels,
    duration
  ) => {
    logger.debug("CampaignCreatePackages:handlePackageSelection", "called...", {
      campaignBudget,
      packageId,
      minClicks,
      selectedChannels
    });

    if (!packageId) {
      setErrorMsg(t("No package name passed"));
      return Actions.campaignCreateUpdatePackageData({
        packageId: undefined,
        lifeTimeBudget: undefined,
        minClicksPackage: undefined
      });
    }

    let data = {};
    if (!isNaN(campaignBudget) && campaignBudget !== "") {
      logger.debug(
        "CampaignCreatePackages:handlePackageSelection",
        "Found a campaignBudget...",
        campaignBudget
      );
      var val = parseInt(campaignBudget, 10);

      const errorMessage = t("Please select a valid price (at least {{minBudget}} EUR).", {
        minBudget: MIN_BUDGET_SIZE
      });

      if (val && val < MIN_BUDGET_SIZE) {
        setErrorMsg(errorMessage);
        return Actions.campaignCreateUpdatePackageData({
          packageId: undefined,
          lifeTimeBudget: undefined,
          minClicksPackage: undefined
        });
      }

      CustomerSucessController.send("CampaignCreatePackages:packageSelection", {
        campaignBudget: campaignBudget,
        packageId
      });

      data = {
        lifeTimeBudget: campaignBudget,
        packageId,
        minClicksPackage: minClicks,
        campaignDuration: duration
      };

      if (selectedChannels) {
        data.selectedChannels = selectedChannels;
      }

      setErrorMsg(undefined);
    } else if (!campaignBudget || campaignBudget === null || campaignBudget === undefined) {
      setErrorMsg("1");
      data = {
        packageId: undefined,
        minClicksPackage: undefined,
        lifeTimeBudget: undefined
      };
    } else if (isNaN(campaignBudget) || campaignBudget === undefined || campaignBudget === null) {
      logger.debug(
        "CampaignCreatePackages:handlePackageSelection",
        "Found a campaignBudget...",
        campaignBudget
      );
      setErrorMsg("2");
      data = {
        packageId: undefined,
        minClicksPackage: undefined,
        lifeTimeBudget: undefined
      };
    } else {
      setErrorMsg(t("Oops, an error occurred. Please contact the support team"));
      data = {
        packageId: undefined,
        minClicksPackage: undefined,
        lifeTimeBudget: undefined
      };
    }

    const campaignBudgetData = { ...data, packages };
    setCampaignBudgetData(campaignBudgetData);

    return Actions.campaignCreateUpdatePackageData(data);
  };

  const renderPackageImage = (nameShort, color) => (
    <div className="campaign-creation__package-image">
      <span className="campaign-creation__letter" style={{ backgroundColor: color || "#a5a5a5" }}>
        {nameShort}
      </span>
    </div>
  );

  const renderPackageHeader = (name, description) => (
    <div className="campaign-creation__center-col">
      <h4 className="campaign-creation__package-name">{name}</h4>
      <p className="campaign-creation__package-desc">{description}</p>
      {renderAdditionalLocCost()}
    </div>
  );

  const onChangeRadioValue = (packageId, budget, minClicks, duration, e) => {
    const selectedChannels = (_.find(packages, { id: packageId }) || {}).selectedChannels;
    handlePackageSelection(budget, packageId, minClicks, selectedChannels, duration);
  };

  const renderRadioButton = (packageId, budget, minClicks, duration) => {
    return (
      <label htmlFor="assistant-package-radio-id" className="container_check">
        <input
          id="assistant-package-radio-id"
          type="radio"
          value={packageId}
          checked={packageType === packageId}
          name="radio"
          onChange={() => onChangeRadioValue(packageId, budget, minClicks, duration)}
        />
        <span className="checkmark_custom" />
      </label>
    );
  };

  const renderBudget = (packageId, budget) => {
    let extraBudget = 0;
    extraBudgetLocations.forEach((elem) => {
      extraBudget += elem.price;
    });

    const classStr = classNames({
      "campaign-creation__pricing-nr": true,
      "campaign-creation__pricing-nr--active": packageId === packageType
    });

    return (
      <span className={classStr}>
        €{formatIntlNumber(budget + extraBudget, { language: userProfile?.language })}
      </span>
    );
  };

  const generatePackageDescription = (duration, minClicks, channels) => {
    return `${duration} Tage Laufzeit / ${minClicks} - ${
      minClicks * 6
    } Mindestklicks / Kanäle: ${channels.join(", ")}`;
  };

  const renderAdditionalLocCost = () => {
    const length = extraBudgetLocations.length;
    const standort = length === 1 ? "Standort" : "Standorte";

    let locationsCost = 0;
    for (let i = 0; i < length; i++) {
      locationsCost += extraBudgetLocations[i].price;
    }
    if (length > 0) {
      return (
        <div style={{ color: "green" }}>
          + {length} Extra {standort} {locationsCost}€
        </div>
      );
    }
  };

  const renderNormalPackage = (
    packageId,
    nameShort,
    name,
    budget,
    description,
    color,
    currentPackageId,
    minClicks,
    channels,
    duration = 30
  ) => {
    logger.debug("CampaignCreatePackages:renderNormalPackage", "called...", {
      packageId,
      nameShort,
      name,
      budget,
      description,
      color,
      currentPackageId,
      minClicks,
      duration
    });

    const classStr = classNames({
      "campaign-creation__package": true,
      "campaign-creation__package--active": packageId === currentPackageId
    });

    const newDesc =
      description ||
      generatePackageDescription(
        duration,
        minClicks,
        channels.map((item) => item.channel_full_name)
      );

    return (
      <div
        className={classStr}
        key={packageId}
        onClick={() => onChangeRadioValue(packageId, budget, minClicks, duration)}
      >
        <div className="campaign-creation__package-item">
          {renderPackageImage(nameShort, color)}
          {renderPackageHeader(name, newDesc)}
          <div className="campaign-creation__pricing right">
            {renderRadioButton(packageId, budget, minClicks, duration)}
            {renderBudget(packageId, budget)}
          </div>
        </div>
      </div>
    );
  };

  const renderPackages = () => {
    packages = _.sortBy(packages, ["name"]);

    if (searchTerm !== "") {
      packages = _.filter(packages, (el) => {
        const st = (searchTerm || "").toLowerCase();
        return (el.name || "").toLowerCase().indexOf(st) > -1;
      });
    }

    logger.debug("CampaignCreatePackages:renderPackages", "called...", {
      packages,
      packageType
    });

    return packages.map((item) => {
      return renderNormalPackage(
        item.id,
        item.nameShort,
        item.name,
        item.budget,
        item.description,
        item.color,
        packageType,
        item.minClicks,
        item.selectedChannels,
        item.duration
      );
    });
  };

  const classSearch = classNames({
    "dashboard__search-close": true,
    "dashboard__search-close--close": searchTerm === ""
  });

  return (
    <div>
      <div className="App campaign-create__pricing-step center fade-in">
        <Heading
          title={t("Select package")}
          subtitle={t(
            "Please select the package that will provide your job advertisement with the required number of visitors"
          )}
        />
        <div className="dashboard__search dashboard__search--packages">
          <input
            type="text"
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={t("Search")}
            value={searchTerm}
            className="dashboard__search-field"
          />
          <div className={classSearch} onClick={() => setSearchTerm("")}>
            x
          </div>
          <p className="error" style={{ marginTop: "6px" }}>
            {errorMsg}
          </p>
          <br />
          <br />
        </div>
        <div className="left">{renderPackages()}</div>
        <br />
        <br />
      </div>
      {children}
    </div>
  );
};

export default withRefluxStore(
  AdAssistantCreatePackages,
  [Store__System, CampaignCreationStore],
  ["userProfile", "packages", "packageId", "extraBudgetLocations"]
);
